import get from './get';
import recover from './recover';

export default [get, recover];
